import * as Actions from '../actions';

const initialNote = {
    header: {
        note_id: 0,
        Description: '',
        NoteType: '',
        Active: 1,
        IsHTML: 0,
    },
    relationList: [],
    is_loaded: false,
    is_open: false,
}

const initialNoteRelation = {
    note_relation_id: 0,
    note_id: 0,
    DisplayOrder: 0,
    NoteReference: '',
    NoteReferenceID: 0,
}

const initialState = {
    note: initialNote,
    noteList: [],
    table_name_view: '',
    table_id_view: 0,
}

const noteReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_NOTE):
        {
            return {
                ...state,
                note: {
                    ...action.payload,
                    is_loaded: true,
                }
            }
        }

        case (Actions.VIEW_NOTE):
        {
            return {
                ...state,
                note: {
                    ...state.note,
                    is_open: !state.note.is_open,
                }
            }
        }

        case (Actions.GET_NOTE_LIST):
        {
            const table_id   = action.payload.table_id;
            const table_name = action.payload.table_name;
            const noteList   = action.payload.noteList;

            return {
                ...state,
                noteList: noteList,
                table_name_view: table_name,
                table_id_view: table_id,
            }
        }

        case (Actions.UPDATE_NOTE):
        {
            return {
                ...state,
                note: {
                    ...state.note,
                    header: {
                        ...state.note.header,
                        ...action.payload
                    }
                }
            }
        }

        case (Actions.SAVE_NOTE):
        {
            return {
                ...state,
                note: {
                    ...state.note,
                    note_id: action.payload
                },
                noteList: state.noteList.concat({ 
                    ...state.note, 
                    note_id: action.payload
                })
            }
        }

        case (Actions.CLEAR_NOTE):
        {
            return {
                ...state,
                note: initialNote
            }
        }

        case (Actions.SET_NOTE_LOADED):
        {
            const table_name = action.payload.table_name;
            const table_id   = action.payload.table_id;
            
            return {
                ...state,
                note: {
                    ...state.note,
                    is_loaded: true,
                    relationList: [{
                        ...initialNoteRelation,
                        NoteReference: table_name,
                        NoteReferenceID: table_id,
                    }]
                },
            }
        }

        case (Actions.DELETE_NOTE):
        {
            return {
                ...state,
                note: initialNote,
                noteList: state.noteList.filter((note) => note.header.note_id !== action.payload)
            }
        }

        default:
        {
            return state;
        }

    }
}

export default noteReducer;


// WEBPACK FOOTER //
// src/main/components/note/store/reducers/note.reducer.js